import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";

import Divider from "@material-ui/core/Divider";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {EnteroSolo, FieldsJs} from "../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {ClienteFacturacionExtService} from "../../../../services/ClienteFacturacionExtService/ClienteFacturacionExtService";
import {BotonAccionAbrirModal, BotonAccionFooterModal, TituloHeaderModal} from "../../../Include/MiniComponents/GlobalComponent";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import {
	AddOutlined,
	AlternateEmailOutlined,
	CancelOutlined,
	DeleteOutlined,
	EditOutlined,
	GrainOutlined,
	HdrStrongOutlined,
	HdrWeakOutlined,
	HowToVoteOutlined,
	ImageAspectRatioOutlined,
	PhoneIphoneOutlined,
	PhoneOutlined,
	PinDropOutlined,
	SaveOutlined,
	StreetviewOutlined,
	TurnedInNotOutlined,
	Description, PlaylistAddOutlined, Edit, Group
} from "@material-ui/icons";
import {CatService} from "../../../../services/_Cat/CatService/CatService";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import Fab from "@material-ui/core/Fab";
import VistaVacia from "../../../Include/VistaVacia/VistaVacia";
import carrito_de_compra_3 from "../../../../assets/img/icons/contacto_tarjeta.svg";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {CONFIG} from "../../../../settings/Config/Config";
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import {ReactMultiEmail} from "react-multi-email";
import ModalEmpresa from "../../EmpresaFacturacion/Includes/ModalEmpresaFacturacion";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import empresa_default from "../../../../assets/img/icons/business.svg";

class ModalEmpresasRelacionadas extends Component {
	
	state = {};
	
	Usr = {};
	
	constructor(props) {
		super(props);
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.state = {
			modal: {
				open: false
			},
			
			tipo: props.tipo,
			
			id_usuario: this.Usr.id_usuario,
			id_cliente: (props.item || {}).id_cliente,
			id_cat_tipo_persona: '1',
			tipo_persona: 'fisica',
			nombre_razon_social: '',
			correo_electronico: [],
			correo_electronico_copia: [],
			telefono: '',
			rfc: '',
			curp: '',
			registro_identidad_fiscal: '',
			id_cat_pais: '',
			id_cat_regimen_fiscal: '',
			cat_pais: [],
			cat_regimen_fiscal: [],
			
			
			listar_empresa: [],
			empresas_relacionadas: [],
			id_empresa: '',
			empresa: null,
			
			activo: true,
			
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			}
		});
	};
	
	open = () => {
		this.init().then(r => {
			this.ListaEmpresa().then(() => {
				this.detalle();
				this.openModal();
			});
		}).catch(e => {
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve) => {
			resolve(true);
		});
	};
	
	is_view = () => {
		return this.props.tipo === 'view';
	};
	
	is_root = () => {
		return FieldsJs.inArray([1], this.Usr.id_cat_tipo_usuario);
	};
	
	save = () => {
		
			ClienteFacturacionExtService.RelacionEmpresa(this.state).then((response) => {
				this.close();
				this.props.RefreshList(response.data);
				this.props.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.props.showSnackBars('error', error.mensaje);
			});
		
	};
	
	add = () => {
		const {item} = this.props;
		this.setState({
			id_usuario: this.Usr.id_usuario,
			id_cliente: item.id_cliente || '',
			id_cat_tipo_persona: '',
			id_empresa: '',
			empresa: null,
			nombre_razon_social: '',
			correo_electronico: [],
			correo_electronico_copia: [],
			telefono: '',
			regimen_fiscal: '',
			rfc: '',
			curp: '',
			codigo_postal: '',
			registro_identidad_fiscal: '',
			id_cat_pais: '',
			id_cat_regimen_fiscal: '',
			activo: true,
			
		});
		this.open();
	};
	
	edit = () => {
		const {item} = this.props;
		this.detalle(item.id_cliente);
		this.open();
	};
	
	view = () => {
		const {item} = this.props;
		this.detalle(item.id_cliente);
		
		this.open();
	};
	
	detalle = () => {
		ClienteFacturacionExtService.RelacionEmpresaDetalle(this.state).then((response) => {
			let empresa = FieldsJs.Copy(this.state.listar_empresa);
			let relacion = FieldsJs.Copy(response.data);
			
			for (let i = 0; i < empresa.length; i++) {
				empresa[i].check = false;
				for (let x = 0; x < relacion.length; x++) {
					if (Number(relacion[x].id_empresa) === Number(empresa[i].id_empresa)) {
						empresa[i].check = true;
					}
				}
			}
			
			this.setState({
				listar_empresa: empresa,
				empresas_relacionadas: relacion,
			});
		}).catch((error) => {
			this.setState({
				empresas_relacionadas: [],
			});
			this.props.showSnackBars('error', error.mensaje);
		});
	};
	
	is_edited_product = () => {
		return this.state.key !== null && this.state.key > -1;
	};
	
	setEmails = (emails, tipo) => {
		if (!tipo) {
			this.setState({correo_electronico: emails});
		} else {
			this.setState({correo_electronico_copia: emails});
		}
	}
	
	RefreshListEmpresa = (id_empresa) => {
		if (id_empresa > 0) {
			this.setState({
				id_empresa: id_empresa
			})
		}
		this.ListaEmpresa();
	};
	
	ListaEmpresa = () => {
		return new Promise((resolve, reject) => {
			CatService.ListEmpresaFac(2, this.Usr.id_usuario, this.Usr.id_plaza).then((response) => {
				this.setState({
					listar_empresa: response.data,
				});
				resolve(response.data);
			}).catch((error) => {
				this.setState({
					listar_empresa: []
				});
				reject(error);
				this.showSnackBars('error', error.mensaje);
			});
		});
	};
	
	handleChangeEmpresa = (id_empresa, valor) => {
		this.setState({
			empresa: valor,
			id_empresa: valor.id_empresa,
		});
	}
	
	asignarEmpresa = (id_empresa, id_empresa_autorizada) => {
		let empresa = FieldsJs.Copy(this.state.listar_empresa);
		let relacion = FieldsJs.Copy(this.state.empresas_relacionadas);
		let banduser = false;
		let userkey = 0;
		for (let i = 0; i < relacion.length; i++) {
			if (Number(relacion[i].id_empresa) === Number(id_empresa)) {
				banduser = true;
				userkey = i;
			}
		}
		if (!banduser) {
			for (let i = 0; i < empresa.length; i++) {
				if (Number(empresa[i].id_empresa) === Number(id_empresa)) {
					empresa[i].check = true;
					if (id_empresa_autorizada) {
						empresa[i].id_empresa = id_empresa_autorizada;
					}
					relacion.push(empresa[i]);
				}
			}
		} else {
			for (let i = 0; i < empresa.length; i++) {
				if (Number(empresa[i].id_empresa) === Number(id_empresa)) {
					empresa[i].check = false;
				}
			}
			relacion.splice(userkey, 1);
		}
		this.setState({
			listar_empresa: empresa,
			empresas_relacionadas: relacion,
		});
	};
	
	render() {
		
		const is_root = this.is_root();
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'edit':
				funcion = this.edit;
				break;
			case 'add':
				funcion = this.add;
				break;
			case 'view':
				funcion = this.view;
				break;
			default:
				funcion = () => {
				};
		}
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span
							style={{cursor: 'pointer'}}
							children={this.props.componente}
							onClick={() => funcion()}
						/>
					</Fragment>
				) : (
					<BotonAccionAbrirModal
						id={this.state.id_cliente}
						tipo={this.state.tipo}
						onClick={() => funcion()}
					/>
				)}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'md'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						<TituloHeaderModal
							tipo={this.state.tipo}
							titulo={'Empresa(s) Relacionada(s)'}
						/>
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={2}>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Grid container spacing={2}>
									
											{this.state.listar_empresa.map((item, index) => (
												<Fragment key={index}>
													<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
														<div className={'vertical-inline w-95 cursor-pointer'} onClick={() => {
															if (this.props.tipo !== 'view') {
																this.asignarEmpresa(item.id_empresa);
															}
														}}>
															<div className='v-center padding-10-L'>
																<FormGroup row className={'text-center check-recuser'}>
																	<FormControlLabel
																		control={
																			<Checkbox
																				type="checkbox"
																				color="primary"
																				checked={item.check ?? false}
																				value={item.check ?? false}
																				disabled={this.props.tipo === 'view'}
																			/>
																		}
																		label={''}
																	/>
																</FormGroup>
															</div>
															
															<div className={'v-center vertical-inline'}>
																<div className={'v-center w-40-px h-40-px b-r-100 bg-img-contain-x-center-y-center'}>
																	<div className={'margin-10-L'}>
																		<div className={'card-0 b-r-100 w-40-px h-40-px'}>
																			<Avatar
																				style={{
																					width: 40,
																					height: 40
																				}}
																				alt={item.archivo_logo ?? 'Logo'}
																				src={item.archivo_logo ?? CONFIG.logo_default}
																			/>
																		</div>
																	</div>
																</div>
																<Typography variant={'h5'} className={'v-center padding-15-L margin-0 text-black px-13'}>
																	{item.nombre_razon_social}
																</Typography>
															</div>
														</div>
													</Grid>
												</Fragment>
											))}
								</Grid>
							</Grid>
						
						</Grid>
					
					</DialogContent>
					
					<Divider/>
					
					<DialogActions>
						<BotonAccionFooterModal
							id={this.state.id_cliente}
							tipo={this.state.tipo}
							close={this.close}
							save={this.save}
						/>
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalEmpresasRelacionadas.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ModalEmpresasRelacionadas;
